import { datadogRum } from '@datadog/browser-rum';
import { FullStory, isInitialized as isFullStoryInitialized } from '@fullstory/browser';

import { Analytics } from '../analytics';
import { UserInfo } from '../api/auth';
import { config } from '../config';
import { Logger } from './Logger';

export const identifyUser = (user: UserInfo) => {
  const name = [user.first_name, user.last_name].filter(Boolean).join(' ') || undefined;
  const userData = {
    id: String(user.user_id),
    ...(user.email && { email: user.email }),
    ...(name && { name }),
  };

  // FullStory
  if (isFullStoryInitialized()) {
    FullStory('setIdentity', {
      uid: String(user.user_id),
      properties: {
        ...(user.email && { email: user.email }),
        ...(name && { displayName: name }),
      },
    });
  }

  // Datadog RUM
  if (config.dataDogEnabled) {
    datadogRum.setUser(userData);
  }

  // Custom logger
  Logger.setUser(userData);

  // CCPA "Do Not Sell": block ad-sale Segment destinations for this user's events
  if (user.is_opted_out_of_sale) {
    Analytics.getInstance().disableSalesIntegrations();
  }

  // Segment analytics
  Analytics.getInstance().identify({
    userId: String(user.user_id),
    email: user.email ?? undefined,
    firstName: user.first_name ?? undefined,
    lastName: user.last_name ?? undefined,
  });
};
